import { graphql } from '@/shared/graphql/generated'

/**
 * Datenschicht des Anmeldebereichs. Die Profilzeile wird einmal pro Anmeldung
 * angelegt, falls sie fehlt - `update_columns: []` macht daraus ein reines
 * "nur einfügen, wenn noch nicht da".
 */

export const ENSURE_USER_PROFILE = graphql(`
  mutation EnsureUserProfile($userId: uuid!) {
    insert_user_profiles_one(
      object: { user_id: $userId }
      on_conflict: { constraint: user_profiles_user_id_key, update_columns: [] }
    ) {
      id
    }
  }
`)
